jQuery(function($){
	$('.store-layout.purchase-button-type--more-info-window .more-info-trigger').on('click', function(){
		showPurchaseButtons($(this), '.more-info-menu');
	});

	$('.store-layout.purchase-button-type--cart-popup .popup-cart').on('click', function(){
		showPurchaseButtons($(this), '.popup-cart');
	});

	$('.store-layout-overlay').on('click', function(){
		$('.more-info-menu').removeClass('showing');
		$('.popup-cart').removeClass('showing');
		$('.store-item').removeClass('showing');
		$('.store-layout-overlay').removeClass('visible');
	});

	function showPurchaseButtons(el, selector) {
		const isShowing = el.closest('.store-item').hasClass('showing');
		$('.store-item').removeClass('showing');
		$(selector).removeClass('showing');
		if(!isShowing) {
			el.addClass('showing').closest('.store-item').addClass('showing');
			$('.store-layout-overlay').addClass('visible');
		} else {
			$('.store-layout-overlay').removeClass('visible');
		}
	}

	$('.purchase-button a').click(function(e){
		if($(this).closest('.purchase-button').hasClass('check-voicing')) {
			e.preventDefault();
			e.stopPropagation();

			console.log($(this));
			console.log('clicked');

			const parentDiv = $(this).closest('.purchase-button');
			const parentButtonDiv = $(this).closest('.purchase-buttons-wrapper');
			const containerClass = parentButtonDiv.attr('container');
			console.log(parentButtonDiv);

			//Show Modal
			$('.popup-cart').removeClass('showing');

			const songTitle = decodeURIComponent(atob(parentDiv.attr('song_title')));
			const modalWrapper = $('#confirm-voicing-modal-wrapper');

			//Checkboxes
			const voicingJson = JSON.parse(atob(parentDiv.attr('voicing_options')));

			console.log(voicingJson);
			const voicingButtonType = parentDiv.attr('button_type');
			const voicingCheckboxes = getVoicingOptionCheckboxes(voicingJson, voicingButtonType, parentButtonDiv);
			console.log(voicingCheckboxes);

			if($('.store-layout-overlay.visible').length) $('.store-layout-overlay').removeClass('visible');
			if($('.store-item.showing').length) $('.store-item').removeClass('showing');
			if($('.more-info-trigger.showing').length) $('.more-info-trigger').removeClass('showing');

			modalWrapper.find('.arrangement-modal-song-title span.song-title').html(songTitle);
			modalWrapper.find('.arrangement-modal-button-type .button-type').html(voicingButtonType);
			modalWrapper.find('.arrangement-modal-container-class .container-class').val(containerClass);
			modalWrapper.find('.arrangement-modal-background').addClass('visible');
			modalWrapper.find('.arrangement-modal').addClass('showing');
			modalWrapper.find('.voicing-confirm > a').attr('class', 'voicing disabled').attr('href', '');

			modalWrapper.find('.voicing-options').html(voicingCheckboxes);
		} else {
			console.log('clicked without restriction')
		}
	});

	$('#confirm-voicing-modal-wrapper').on('change', 'input[name="voicing-option"]', function(){
		const confirmClass = $(this).attr('confirm_class');
		const confirmButton = $(this).closest('.arrangement-modal-body').find('.voicing-confirm > a');
		const songId = $(this).closest('.voicing-option').attr('song_id');
		const buttonType = $(this).closest('.arrangement-modal').find('.arrangement-modal-button-type .button-type').html();
		const voicingTitle = $(this).closest('.voicing-option').attr('voicing_title');
		const href = $(this).closest('.voicing-option').attr('song_href');

		confirmButton.attr('class', 'voicing').addClass(confirmClass).attr('song_id', songId)
			.attr('confirm_class', confirmClass)
			.attr('button_type', buttonType)
			// .attr('href', href)
			.attr('voicing_title', voicingTitle);

		//Remove .check-voicing
		$('#purchase-buttons--' + songId + ' .purchase-button').addClass('check-voicing');

		const approvedButton = $('#purchase-buttons--' + songId + ' .purchase-buttons.' + confirmClass + ' .purchase-button[button_type="' + buttonType + '"]');
		approvedButton.removeClass('check-voicing');
	});

	$('#confirm-voicing-modal-wrapper').on('click', '.arrangement-modal-body .voicing-confirm > a:not(.disabled)', function(e){
		e.preventDefault();

		const confirmClass = $(this).attr('confirm_class');
		const songId = $(this).attr('song_id');
		const buttonType = $(this).attr('button_type');
		const voicingTitle = $(this).attr('voicing_title').replace('+', '_');
		const containerClass = $(this).closest('.arrangement-modal-wrapper').find('.arrangement-modal-container-class .container-class').val();

		const approvedButtons = $('#purchase-buttons--' + songId + '[container="' + containerClass + '"] .purchase-buttons.' + confirmClass + ' .purchase-button[button_type="' + buttonType + '"] a');
		console.log('#purchase-buttons--' + songId + '[container="' + containerClass + '"] .purchase-buttons.' + confirmClass + ' .purchase-button[button_type="' + buttonType + '"] a')
		console.log(approvedButtons.length)

		closeCheckVoicingModal($(this));


		if($('.store-item.song-id--' + songId).length) {
			$('.store-item.song-id--' + songId).removeClass(function(index, className){
				return (className.match (/(^|\s)voicing-showing--\S+/g) || []).join(' ');
			}).addClass('voicing-showing--' + voicingTitle);
			$('.store-item.song-id--' + songId).addClass('showing');
			$('.store-layout-overlay').addClass('visible');
			if($('.store-item.song-id--' + songId + ' .popup-cart').length) {
				$('.store-item.song-id--' + songId + ' .popup-cart').addClass('showing');
			}
			if($('.store-item.song-id--' + songId + ' .more-info-menu').length) {
				$('.store-item.song-id--' + songId + ' .more-info-menu').addClass('showing');
			}
		}
		if($('.single-cs-song-wrapper').length) {
			$('.single-cs-song-wrapper').removeClass(function(index, className){
				return (className.match (/(^|\s)voicing-showing--\S+/g) || []).join(' ');
			}).addClass('voicing-showing--' + voicingTitle);
		}

		setTimeout(function(){
			approvedButtons.each(function(){
				this.click();
			});
		}, 200);
		setTimeout(function(){
			approvedButtons.each(function(){
				$(this).closest('.purchase-button').addClass('check-voicing');
			});
		}, 500);
	});

	function getVoicingOptionCheckboxes(voicingJson, voicingButtonType, parentButtonDiv) {
		let voicingHtml = '';

		$.each(voicingJson, function(){
			console.log('.purchase-button.voicing--' + this.voicing_class + '[button_type="' + voicingButtonType + '"]');
			console.log(parentButtonDiv.find('.purchase-button.voicing--' + this.voicing_class + '[button_type="' + voicingButtonType + '"]').length);

			console.log(this);
			if(parentButtonDiv.find('.purchase-button.voicing--' + this.voicing_class + '[button_type="' + voicingButtonType + '"]').length) {
				voicingHtml += '<div class="voicing-option voicing voicing--' + this.voicing_class + '" voicing_title="' + this.voicing_class + '" song_id="' + this.song_id + '" song_href="' + this.href + '">';
				voicingHtml += '<label for="' + this.checkbox_id + '"><div class="voicing-title-display">' + this.voicing_title + '</div> Voicing</label>';
				voicingHtml += '<input type="radio" id="' + this.checkbox_id + '" name="voicing-option" value="' + this.value + '" confirm_class="voicing--' + this.voicing_class + '">';
				voicingHtml += '</div>';
			}
		})

		return voicingHtml;
	}

	function closeCheckVoicingModal(el) {
		const modalWrapper = el.closest('.arrangement-modal-wrapper');
		modalWrapper.find('.arrangement-modal').removeClass('showing');
		modalWrapper.find('.arrangement-modal-background').removeClass('visible');
	}

});